import _defineProperty from "/Users/edward/Desktop/hampercompany-ie/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { list, save, clear, listen } from './utils/localstorage';

var get = function get(id) {
  return list().find(function (product) {
    return product.id === id;
  });
};

var exists = function exists(id) {
  return !!get(id);
};

var add = function add(product, quantity) {
  return isValid(product) ? exists(product.id) ? update(product.id, 'quantity', get(product.id).quantity + (quantity || 1)) : save(list().concat(_objectSpread(_objectSpread({}, product), {}, {
    quantity: quantity || 1
  }))) : null;
};

var remove = function remove(id) {
  return save(list().filter(function (product) {
    return product.id !== id;
  }));
};

var quantity = function quantity(id, diff) {
  return exists(id) && get(id).quantity + diff > 0 ? update(id, 'quantity', get(id).quantity + diff) : remove(id);
};

var update = function update(id, field, value) {
  return save(list().map(function (product) {
    return product.id === id ? _objectSpread(_objectSpread({}, product), {}, _defineProperty({}, field, value)) : product;
  }));
};

var total = function total(cb) {
  return list().reduce(function (sum, product) {
    return isCallback(cb) ? cb(sum, product) : sum += subtotal(product);
  }, 0);
};

var destroy = function destroy() {
  return clear();
};

var onChange = function onChange(cb) {
  return isCallback(cb) ? listen(cb) : console.log(typeof cb);
};

var isValid = function isValid(product) {
  return product.id && product.price;
};

var subtotal = function subtotal(product) {
  return isCalcable(product) ? product.price * product.quantity : 0;
};

var isCalcable = function isCalcable(product) {
  return product && product.price && product.quantity;
};

var isCallback = function isCallback(cb) {
  return cb && typeof cb === "function";
};

export { list, get, add, remove, update, quantity, total, destroy, exists, subtotal, onChange };